<template>

    <li>
        <hierarchy-item :current="currentDclidentity"  :item="item" :key="item.dclIdentity"/>
        <ul v-if="item.childs.length !== 0">
            <tree-item :current="currentDclidentity" v-for="nodeItem in item.childs" :node="nodeItem" :key="nodeItem.dclIdentity" />
        </ul>
    </li>

</template>
<script>
    import HierarchyItem from './HierarchyItem';
    export default {
        props: ['node','current'],
        components: {
            TreeItem: () => import('./TreeItem')
            , HierarchyItem
        },
        data() {
            return {
                currentDclidentity: this.current,
                item: this.node
            }
        }
    }

</script>
<style>
</style>